import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import LandingPage from "./pages/LandingPage";
import AdminLeads from "./pages/AdminLeads";
import AdminLogin from "./pages/AdminLogin";
import AuthCallback from "./pages/AuthCallback";
import { Toaster } from "./components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function App() {
  return (
    <div className="App min-h-screen bg-white text-slate-900">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage backendUrl={BACKEND_URL} />} />
          <Route path="/admin/login" element={<AdminLogin backendUrl={BACKEND_URL} />} />
          <Route path="/auth/callback" element={<AuthCallback backendUrl={BACKEND_URL} />} />
          <Route path="/admin/leads" element={<AdminLeads backendUrl={BACKEND_URL} />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
